import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { CoursesListVM } from "./CoursesListVM";
import { TermPeriod } from "../../Models/Course";

export class PeriodEditingVM extends InterActive{
    private details:TermPeriod = { id:'', course_id:'' , start:'' , end:'', hours:'' }
    private editedDetails:TermPeriod = { id:'', course_id:'' , start:'' , end:'', hours:'' }
    private editMode:boolean = false
    private buttonsVisibility:boolean = false
    private deleting:boolean = false
    private available:boolean = true

    public get Details():TermPeriod{ return this.details }
    public get EditedDetails():TermPeriod { return this.editedDetails }
    public get EditMode():boolean { return this.editMode } 
    public get ButtonsVisibility():boolean { return this.buttonsVisibility }
    public get Deleting():boolean { return this.deleting }
    public get Available():boolean { return this.available }

    public set Start(value:string){ this.editedDetails.start = value; this.editMode = true ; this.buttonsVisibility = true; this.update() }
    public set End(value:string){ this.editedDetails.end = value; this.editMode = true ; this.buttonsVisibility = true;this.update() }
    public set Hours(value:string){ this.editedDetails.hours = value; this.editMode = true ; this.buttonsVisibility = true;this.update() }
    public set Deleting(value:boolean){ this.deleting = value; this.update() }
    public set Available(value:boolean){ this.available = value; this.update() }

    constructor(details:TermPeriod){
        super()
        this.details = {...details}
        this.editedDetails = {...details}
    }

    public cancel(){
        this.editedDetails = {...this.details}
        this.buttonsVisibility = false
        this.editMode = false
        this.update()
    }

    public async sendEdit(create:boolean = false, vm?:CoursesListVM){
        this.buttonsVisibility = false
        this.update()
        if(create){
            try{
                const response = await ApiRequest.createPeriod(this.editedDetails.course_id , this.editedDetails.start , this.editedDetails.end , this.editedDetails.hours)
                if(response){
                    if(response.status === HttpStatusCode.Ok ){
                        if(response.data.status){
                            this.editedDetails.id = response.data.data.id
                            if(vm)vm.pushItem(this.editedDetails)
                            this.editMode = false
                            this.editedDetails = this.details
                            Notify({type:'success' , title:'عملية ناجحة' , body:'تم انشاء دفعة جديدة بنجاح'})
                        } else {
                            this.buttonsVisibility = true
                            Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                        }
                    }else{
                        this.buttonsVisibility = true
                        Notify({type:'danger' , title:'فشل العملية', body:'فشل العملية .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }else{
                    this.buttonsVisibility = true
                    Notify({type:'danger' , title:'فشل العملية', body:'فشل العملية .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
                this.update()
            }catch{
                this.buttonsVisibility = true
                Notify({type:'danger' , title:'فشل العملية', body:'فشل العملية .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                this.update()
            }
        } else {
            try{
                const response = await ApiRequest.editPeriod(this.editedDetails.id , this.editedDetails.start , this.editedDetails.end , this.editedDetails.hours)
                if(response){
                    if(response.status === HttpStatusCode.Ok ){
                        if(response.data.status){
                            this.editMode = false
                            this.details = {...this.editedDetails}
                        } else {
                            this.buttonsVisibility = true
                            Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                        }
                    }else{
                        this.buttonsVisibility = true
                        Notify({type:'danger' , title:'فشل العملية', body:'فشل العملية .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }else{
                    this.buttonsVisibility = true
                    Notify({type:'danger' , title:'فشل العملية', body:'فشل العملية .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
                this.update()
            }catch{
                this.buttonsVisibility = true
                Notify({type:'danger' , title:'فشل العملية', body:'فشل العملية .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                this.update()
            }
        }

    }

    public async delete(){
        this.available = false
        this.update()
        try{
            const response = await ApiRequest.deletePeriod(this.details.id)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        this.available = false
                        Notify({type:'success' , title:'تمت العملية بنجاح' , body:'تمت عملية الحذف بنجاح'})
                        this.update()
                    }else{
                        this.available = true
                        this.deleting = false
                        Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                        this.update()
                    }
                }else{ 
                    this.available = true
                    this.deleting = false
                    Notify({type:'danger' , title:'فشل العملية', body:'فشل عملية الحذف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    this.update()
                }
            }
        }catch{ 
            this.available = true
            this.deleting = false
            Notify({type:'danger' , title:'فشل العملية', body:'فشل عملية الحذف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) 
            this.update()
        }
    }

}